import EditField from 'components/DocumentDetail/Editor/EditField'
import EditRow from 'components/DocumentDetail/Editor/EditRow'
import { Field } from 'components/DocumentDetail/types'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

const VENDOR_CODE_NAME = 'headerBillFrom.vendorCode'

type Props = Field & {
  style?: any
}
const VendorItemRow = ({ style, ...field }: Props) => {
  const { trigger } = useFormContext()
  const { name } = field

  useEffect(() => {
    if (name === VENDOR_CODE_NAME) {
      // a hack to trigger vendorcode validation ater value is set
      setTimeout(() => trigger(name), 0)
    }
  }, [trigger, name])

  return (
    <EditRow style={style} label={field.label}>
      <EditField {...field} type="text" compProps={{ ...field?.compProps, disabled: true }} />
    </EditRow>
  )
}

export default VendorItemRow
